import { useState } from 'react';
import ContactModal from '../../../components/feature/ContactModal';
import DemoBookingModal from '../../../components/feature/DemoBookingModal';

export default function CTA() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const handleFreeTrial = () => {
    window.open('http://112.74.46.225:8002/admin/login?register=register', '_blank');
  };

  return (
    <>
      <section id="contact" className="relative py-24 overflow-hidden">
        {/* 背景图片 */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20flowing%20gradient%20waves%20in%20teal%20cyan%20and%20blue%20colors%20creating%20elegant%20minimalist%20atmosphere%20professional%20business%20aesthetic%20with%20smooth%20curves%20soft%20lighting%20and%20clean%20geometric%20patterns&width=1920&height=800&seq=cta-bg-tech-001&orientation=landscape"
            alt="CTA Background"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        {/* 装饰光效 */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-400/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>

        <div className="max-w-6xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="text-center space-y-8 animate-fade-in">
            {/* 标签 */}
            <div className="inline-flex items-center bg-white/95 backdrop-blur-md border border-white/30 text-teal-600 px-6 py-3 rounded-full text-sm font-bold shadow-xl">
              <i className="ri-rocket-line mr-2 text-lg"></i>
              立即开始
            </div>

            {/* 主标题 */}
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight drop-shadow-lg">
              准备好开启智能管理之旅了吗？
            </h2>

            {/* 副标题 */}
            <p className="text-xl sm:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed drop-shadow-md">
              立即注册，免费试用 ，体验智研云带来的高效便捷
            </p>

            {/* 特色亮点 */}
            <div className="flex flex-wrap justify-center gap-6 py-6">
              <div className="flex items-center bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20">
                <i className="ri-check-line text-teal-300 text-xl mr-2"></i>
                <span className="text-white font-medium">无需信用卡</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20">
                <i className="ri-check-line text-teal-300 text-xl mr-2"></i>
                <span className="text-white font-medium">随时取消</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20">
                <i className="ri-check-line text-teal-300 text-xl mr-2"></i>
                <span className="text-white font-medium">专属客服</span>
              </div>
            </div>

            {/* CTA按钮 */}
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center pt-4">
              <button
                onClick={handleFreeTrial}
                className="group relative bg-white text-gray-900 px-12 py-6 rounded-2xl text-lg font-bold shadow-2xl hover:shadow-[0_20px_60px_rgba(255,255,255,0.3)] transition-all cursor-pointer whitespace-nowrap hover:scale-105"
              >
                <span className="flex items-center justify-center">
                  <i className="ri-rocket-line mr-3 text-2xl group-hover:rotate-45 transition-transform duration-500"></i>
                  立即免费试用
                </span>
              </button>
              <button
                onClick={() => setIsDemoModalOpen(true)}
                className="group bg-transparent text-white px-12 py-6 rounded-2xl text-lg font-bold border-2 border-white/50 hover:border-white hover:bg-white/10 backdrop-blur-md transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl hover:scale-105"
              >
                <span className="flex items-center justify-center">
                  <i className="ri-customer-service-line mr-3 text-2xl group-hover:scale-110 transition-transform"></i>
                  预约演示
                </span>
              </button>
            </div>

            {/* 信任徽章 */}
            <div className="pt-12 grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="flex flex-col items-center space-y-3 group cursor-pointer">
                <div className="w-16 h-16 bg-white/10 backdrop-blur-md rounded-2xl flex items-center justify-center border border-white/20 group-hover:scale-110 transition-transform">
                  <i className="ri-shield-check-line text-4xl text-teal-300"></i>
                </div>
                <span className="text-white/90 font-medium text-sm">安全可靠</span>
              </div>
              <div className="flex flex-col items-center space-y-3 group cursor-pointer">
                <div className="w-16 h-16 bg-white/10 backdrop-blur-md rounded-2xl flex items-center justify-center border border-white/20 group-hover:scale-110 transition-transform">
                  <i className="ri-award-line text-4xl text-cyan-300"></i>
                </div>
                <span className="text-white/90 font-medium text-sm">行业认证</span>
              </div>
              <div className="flex flex-col items-center space-y-3 group cursor-pointer">
                <div className="w-16 h-16 bg-white/10 backdrop-blur-md rounded-2xl flex items-center justify-center border border-white/20 group-hover:scale-110 transition-transform">
                  <i className="ri-customer-service-2-line text-4xl text-blue-300"></i>
                </div>
                <span className="text-white/90 font-medium text-sm">7×24支持</span>
              </div>
              <div className="flex flex-col items-center space-y-3 group cursor-pointer">
                <div className="w-16 h-16 bg-white/10 backdrop-blur-md rounded-2xl flex items-center justify-center border border-white/20 group-hover:scale-110 transition-transform">
                  <i className="ri-refresh-line text-4xl text-teal-300"></i>
                </div>
                <span className="text-white/90 font-medium text-sm">持续更新</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
      
      <DemoBookingModal 
        isOpen={isDemoModalOpen} 
        onClose={() => setIsDemoModalOpen(false)} 
      />
    </>
  );
}
